/**
 * Given a date (local, because in browser zone is the only way new Date() works)
 * re-zone into UTC. Prefer moment for stuff like this, ideally. Use this if you
 * truly need Dates though.
 *
 * @param date
 * @return {Date}
 */
export default function convertDateToUTC(date) {
  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds()
  );
}
